import { Axios } from 'axios'

export type NoticeData = {
  title: string;
  detail: string;
  startDate: string;
  endDate: string;
}

export type NoticeItem = {
  noticeId: number;
  title: string;
  detail: string;
  startDate: string;
  endDate: string;
}

export type ResponseAdd = {
  noticeId: number;
}

export interface NoticeRepository {
  list(): Promise<NoticeItem[]>
  get(noticeId: number): Promise<NoticeData>;
  addNotice(request: NoticeData): Promise<ResponseAdd>;
  updateNotice(noticeId: number, request: NoticeData): Promise<void>;
  deleteNotice(noticeId: number): Promise<void>
}

export class NoticeRepositoryImpl implements NoticeRepository {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios
  private readonly baseUrl = 'system/notice'

  async list (): Promise<NoticeItem[]> {
    const { data } = await this.http.get(this.baseUrl)
    return data
  }

  async get (noticeId: number): Promise<NoticeData> {
    const url = `${this.baseUrl}/${noticeId}`
    const { data } = await this.http.get(url)
    return data
  }

  async addNotice (request: NoticeData): Promise<ResponseAdd> {
    const { data } = await this.http.post(this.baseUrl, request)
    return data
  }

  async updateNotice (noticeId: number, request: NoticeData): Promise<void> {
    const url = `${this.baseUrl}/${noticeId}`
    await this.http.put(url, request)
  }

  async deleteNotice (noticeId: number): Promise<void> {
    const url = `${this.baseUrl}/${noticeId}`
    await this.http.delete(url)
  }
}
